import { motion } from 'framer-motion';

// Official WhatsApp Logo SVG
const WhatsAppIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.472 14.382C17.112 14.202 15.344 13.332 15.016 13.172C14.688 13.012 14.448 12.932 14.208 13.292C13.968 13.652 13.28 14.452 13.072 14.692C12.864 14.932 12.656 14.964 12.296 14.784C11.936 14.604 10.776 14.224 9.4 13C8.304 12.024 7.564 10.82 7.348 10.452C7.132 10.084 7.324 9.884 7.504 9.704C7.664 9.544 7.86 9.284 8.04 9.076C8.22 8.868 8.28 8.708 8.4 8.468C8.52 8.228 8.46 8.02 8.36 7.82C8.26 7.62 7.54 5.86 7.24 5.152C6.948 4.464 6.652 4.56 6.428 4.56L5.788 4.556C5.564 4.556 5.2 4.636 4.892 4.976C4.584 5.316 3.72 6.128 3.72 7.776C3.72 9.424 4.892 10.996 5.06 11.216C5.228 11.436 7.356 14.716 10.616 16.124C11.392 16.46 12 16.656 12.484 16.808C13.268 17.06 13.988 17.02 14.56 16.936C15.2 16.84 16.532 16.128 16.808 15.348C17.084 14.568 17.084 13.908 17.004 13.772C16.924 13.636 16.708 13.556 16.348 13.376H17.472Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M12.004 2C6.484 2 2 6.484 2 12C2 13.824 2.484 15.588 3.396 17.156L2 22L7.02 20.696C8.528 21.528 10.244 21.968 12.004 21.968C17.524 21.968 22.008 17.484 22.008 12C22.008 6.484 17.524 2 12.004 2ZM12.004 20.204C10.428 20.204 8.928 19.74 7.644 18.924L7.332 18.732L4.352 19.508L5.16 16.632L4.956 16.296C4.068 14.764 3.6 13.388 3.6 12C3.6 7.364 7.368 3.6 12.004 3.6C16.64 3.6 20.408 7.364 20.408 12C20.408 16.636 16.64 20.204 12.004 20.204Z" />
  </svg>
);

const WHATSAPP_NUMBER = '905537942161';
const DEFAULT_MESSAGE = 'Merhaba, ürünleriniz hakkında bilgi almak istiyorum.';

interface WhatsAppButtonProps {
  message?: string;
}

/**
 * Floating WhatsApp Button - Türkiye pazarı için kritik CTA
 * Sağ alt köşede sabit pozisyonda duran WhatsApp butonu
 */
export function WhatsAppButton({ message = DEFAULT_MESSAGE }: WhatsAppButtonProps) {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, duration: 0.4, type: 'spring', stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-[60] flex items-center gap-3 group"
      aria-label="WhatsApp ile iletişime geçin"
    >
      {/* Tooltip - Always visible on desktop hover */}
      <motion.span
        initial={{ opacity: 0, x: 10 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 2.5, duration: 0.3 }}
        className="hidden md:block bg-white px-4 py-2 shadow-lg text-sm font-medium text-gray-800
                   opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg whitespace-nowrap"
      >
        WhatsApp ile yazın
      </motion.span>

      {/* Button */}
      <div className="relative">
        <div
          className="relative w-14 h-14 md:w-16 md:h-16 flex items-center justify-center
                     shadow-lg shadow-[#25D366]/30 rounded-full bg-[#25D366] hover:bg-[#20bd5a] transition-colors"
        >
          <WhatsAppIcon className="w-8 h-8 md:w-9 md:h-9 text-white" />
        </div>

        {/* Pulse animation ring */}
        <span className="absolute inset-0 rounded-full border-2 border-[#25D366] animate-ping opacity-75" />
      </div>
    </motion.a>
  );
}
